export default "__VITE_ASSET__962a74eb__"